<template>
  <div class="card border-radius-none">
    <div class="commandes__ligne commandes__ligne--border-width">

      <div class="commandes__ligne-selecteurs" style='--margin: 1.2em 0 0 0;'>
        <b-icon class="drag" icon="drag"
                  :class="{
                    'pointer-no-drop' : disabledDraggable,
                    'draggable-handle' : !disabledDraggable
                  }">
        </b-icon>
        <b-checkbox v-model="ligneCommande.selected"
          class="mgl-20px">
        </b-checkbox>
      </div>

      <div class="commandes__ligne-libelle">
        <b-field
          custom-class="is-size-7 is-marginless has-text-link"
          :label="$t('detail.article.libelle')">
          <remise-personnalisee
            v-model="ligneCommande.libelle"
            @setRemiseRegie="setRemiseRegie($event)"
            :rows="nbLignesLibelle"
            class="custum-auto-complete">
          </remise-personnalisee>
        </b-field>
      </div>

      <div class="card-article-input-price-remise">
        <span v-if="ligneCommande.totalHt">
          {{ligneCommande.totalAvantRemise | formatDevise}}
        </span>
        <span v-else> {{ 0.00 | formatDevise }}</span>
      </div>

      <div class='mgr-10px'>
        <b-field :label="$t('detail.article.discount')"
          custom-class="is-size-7 is-marginless has-text-link">
          <b-field>
            <input-currency ref="remise" v-model="valeurPourcentage"
              isNumber="true"
              @input="calcul()"
              :disabled="estRemisePersonalisee()">
            </input-currency>
            <b-dropdown position="is-bottom-left">
              <button class="button " slot="trigger">
                <span>{{$t(typeRemiseInitial)}}</span>
                <b-icon icon="menu-down"></b-icon>
              </button>
              <b-dropdown-item v-for="typeRemise in listeTypeRemiseLigne"
                :key="typeRemise.code"
                v-model="typeRemise.code"
                @click="changerTypeRemise(typeRemise)">
                {{$t(typeRemise.libelle)}}
              </b-dropdown-item>
            </b-dropdown>
            </b-field>
        </b-field>
      </div>

      <div class="commandes__fin-ligne">
        <div class="has-text-weight-semibold">
          <span v-if="ligneCommande.totalHt" class="is-fullwidth ellipsis">
            {{ligneCommande.totalHt | formatDevise}}
          </span>
          <span v-else> {{ 0.00 | formatDevise }} </span>
        </div>
        <div></div>
        <b-dropdown position="is-bottom-left" aria-role="list">
          <a slot="trigger">
            <b-icon
              custom-class="has-text-icon-more"
              icon="dots-vertical">
            </b-icon>
          </a>
          <b-dropdown-item aria-role="listitem" @click="inProgress()">
            <div class="media">
              <div class="media-content">
                <p class="is-default font-dropdown">{{ $t('editionRemise.duplicateLine')}}</p>
              </div>
            </div>
          </b-dropdown-item>
          <b-dropdown-item aria-role="listitem" @click="supprimerLigne()">
            <div class="media">
              <div class="media-content">
                <p class="is-default font-dropdown">{{ $t('editionRemise.deleteLine')}}</p>
              </div>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>

    </div>
    <b-modal v-model="isRemisesOpen"
      has-modal-card
      class="modal" @close="cancelRemise()">
      <app-lignes-remise :ligneCommande="ligneCommande"
                         :isReseauTempo="false"
        @setRemiseRegie="setRemiseRegie($event)"
        @validationRemise="validationRemise"
        @cancelRemise="cancelRemise()" />
    </b-modal>
  </div>
</template>

<script>
import inputCurrency from '@/components/general/inputCurrency';
import inProgress from '@/services/general/inProgress';
import * as devisConf from '@/configuration/devisConf';
import * as remiseF2B from '@/services/devisCommandes/traductionRemiseBackFront';
import lignesRemise from '@/components/devisCommandes/editionDevisCommande/lignesRemise';
import remisePersonnalisee from '@/components/devisCommandes/remisePersonnalisee';

export default {
  name: 'ligneRemise',
  props: {
    ligneCommande: Object,
    lignesCommande: Array,
    disabledDraggable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    inputCurrency,
    appLignesRemise: lignesRemise,
    remisePersonnalisee,
  },
  data() {
    return {
      oldTypeRemise: null,
      typeRemiseLocal: null,
      isRemisesOpen: false,
      openPopUpAddEditLibelleRemise: false,
      dataAutoCompleteRemise: [],
    };
  },
  computed: {
    nbLignesLibelle() {
      if (this.ligneCommande.libelle) {
        return this.ligneCommande.libelle.split('\n').length;
      }
      return 1;
    },
    valeurPourcentage: {
      get() {
        return remiseF2B.toMontantRemiseFront(
          this.ligneCommande.typeRemise, this.ligneCommande.remise,
        );
      },
      set(value) {
        remiseF2B.fromMontantRemiseFront(this.ligneCommande, this.typeRemiseLocal, value);
      },
    },
    listeTypeRemiseLigne() {
      // on désactive volontairement les remises par montant
      // non gérées par la création de facture
      return devisConf.LISTE_TYPE_REMISE_LIGNE.filter((type) => (
        type.code !== devisConf.TYPE_REMISE_FRONT_MAJORATION_MONTANT
        && type.code !== devisConf.TYPE_REMISE_FRONT_REMISE_MONTANT
      ));
    },
    typeRemiseInitial() {
      const typeRemise = this.listeTypeRemiseLigne.find((type) => {
        return type.code === this.typeRemiseLocal;
      });
      if (typeRemise) {
        return typeRemise.initiale;
      }
      return '';
    },
  },
  mounted() {
    if (!this.ligneCommande.typeRemise && !this.ligneCommande.remise) {
      remiseF2B.fromTypeRemiseFront(
        this.ligneCommande, devisConf.TYPE_REMISE_FRONT_REMISE_POURCENTAGE,
      );
    }
    this.typeRemiseLocal = remiseF2B.toTypeRemiseFront(
      this.ligneCommande.typeRemise, this.ligneCommande.remise,
    );
  },
  methods: {
    setRemiseRegie(remise) {
      if (!this.ligneCommande.lignesRemise || this.ligneCommande.lignesRemise.length === 0) {
        this.ligneCommande.isRemiseRegie = remise;
      } else {
        this.ligneCommande
          .isRemiseRegie = this.ligneCommande.lignesRemise.some(l => l.isRemiseRegie);
      }
    },
    calcul() {
      this.$emit('reloadTotalHt');
    },
    estRemisePersonalisee() {
      return this.ligneCommande.typeRemise === devisConf.PERSONALISE;
    },
    changerTypeRemise(props) {
      this.oldTypeRemise = this.typeRemiseLocal;
      this.typeRemiseLocal = props.code;
      remiseF2B.fromTypeRemiseFront(this.ligneCommande, this.typeRemiseLocal);
      if (this.estRemisePersonalisee()) {
        this.isRemisesOpen = true;
      } else {
        this.ligneCommande.lignesRemise = [];
        this.ligneCommande.remise = 0;
      }
      this.calcul();
    },
    supprimerLigne() {
      this.lignesCommande.splice(this.lignesCommande.indexOf(this.ligneCommande), 1);
    },
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    validationRemise(ligne) {
      this.ligneCommande.lignesRemise = ligne.lignesRemise;
      this.isRemisesOpen = false;
      this.$emit('reloadTotalHt');
    },
    cancelRemise() {
      this.typeRemiseLocal = this.oldTypeRemise;
      remiseF2B.fromTypeRemiseFront(this.ligneCommande, this.typeRemiseLocal);
      this.isRemisesOpen = false;
    },
  },
};
</script>
